import React from 'react';
import { RadioInput, RadioInputGroup } from '@instructure/ui-radio-input';
import t from 'format-message';
import { SecondaryInfoDisplay } from "../../../../util/gradebook/constants.js";
export var SecondaryInfoSelector = function SecondaryInfoSelector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var inputs = [{
    value: SecondaryInfoDisplay.SIS_ID,
    label: t('SIS ID')
  }, {
    value: SecondaryInfoDisplay.INTEGRATION_ID,
    label: t('Integration ID')
  }, {
    value: SecondaryInfoDisplay.LOGIN_ID,
    label: t('Login ID')
  }, {
    value: SecondaryInfoDisplay.NONE,
    label: t('None')
  }];
  var handleChange = function handleChange(event) {
    onChange(event.target.value);
  };
  return /*#__PURE__*/React.createElement(RadioInputGroup, {
    onChange: handleChange,
    name: "secondary-info-display",
    defaultValue: value.toString(),
    description: t('Secondary info')
  }, inputs.map(function (input) {
    return /*#__PURE__*/React.createElement(RadioInput, {
      key: input.value,
      value: input.value.toString(),
      label: input.label
    });
  }));
};